export default __webpack_public_path__ + "static/media/friendship3.c9b12d1f.jpg";